import { styled } from 'styled-components';

export const SelectListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
